export default function getStartUrl(path: string): string {
    if (!['profile', 'auth', 'worker', 'client', 'order-details'].includes(path.split('/')[0])) {
        path = `/${path}`;
    }

    return path;
}
